/**
 * Lightweight viewer for a demo-imported photo. Standalone — does NOT reuse
 * the platform's PhotoViewerModal so the demo path stays isolated from project
 * data and existing modal state.
 */

import { useDockDemoStore } from '../../stores/dockDemoStore';

export default function DemoPhotoPopup() {
  const selectedId = useDockDemoStore((s) => s.selectedDemoPhotoId);
  const missions = useDockDemoStore((s) => s.missions);
  const setSelected = useDockDemoStore((s) => s.setSelectedDemoPhoto);

  // Photos live on missions now — scan visible missions for a matching id.
  // Even when the source mission is hidden, the viewer can still resolve
  // the photo (a user might click a marker just before unchecking the
  // mission); the renderer guards visibility for on-map markers separately.
  let photo: import('./types').DemoPhoto | undefined;
  for (const m of missions) {
    const found = m.importedPhotos?.find((p) => p.id === selectedId);
    if (found) {
      photo = found;
      break;
    }
  }
  if (!photo) return null;

  return (
    <div className="dock-demo-photo-popup__backdrop" onClick={() => setSelected(null)}>
      <div className="dock-demo-photo-popup" onClick={(e) => e.stopPropagation()}>
        <div className="dock-demo-photo-popup__header">
          <span>
            {photo.fileName}
            <span className="dock-demo-tag">{photo.category.replace('_photo', '')}</span>
          </span>
          <button type="button" onClick={() => setSelected(null)}>×</button>
        </div>
        <div className="dock-demo-photo-popup__body">
          <img src={photo.displayUrl} alt={photo.fileName} />
          <div className="dock-demo-photo-popup__meta">
            {photo.coordinates[0] !== 0 && (
              <span>{photo.coordinates[1].toFixed(6)}, {photo.coordinates[0].toFixed(6)}</span>
            )}
            {photo.altitude !== undefined && <span>alt {photo.altitude.toFixed(1)} m</span>}
            {photo.captureDate && <span>{photo.captureDate}</span>}
          </div>
        </div>
      </div>
    </div>
  );
}
